import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Privileged } from '../../hocs/withPrivileges';
import { assignableMemberType } from '../../types';
import Privileges from '../../utils/Privileges';

UserMemberAssignmentRow.propTypes = {
    assignedMember: assignableMemberType.isRequired,
    isConflicting: PropTypes.bool.isRequired,
    onRemoveMemberAssignment: PropTypes.func.isRequired,
};

function UserMemberAssignmentRow(props) {
    const {
        assignedMember,
        isConflicting,
        onRemoveMemberAssignment,
    } = props;
    const { t } = useTranslation();
    const sufficientPrivileges = [Privileges.USER_EDIT];
    return (
        <div key={assignedMember.memberId} className="detail-list-row">
            <Privileged sufficientPrivileges={sufficientPrivileges}>
                <div className="member-cell--small member-row--remove">
                    <button
                        type="button"
                        className={`remove-button button-small ${isConflicting ? 'button-bordered-red' : 'button-bordered'}`}
                        onClick={onRemoveMemberAssignment}
                    >
                        <span aria-label={t('misc.remove-member-assignment')} title={t('misc.remove-member-assignment')} role="img">
                            <FontAwesomeIcon icon="times" />
                        </span>
                    </button>
                </div>
            </Privileged>
            <div className="member-cell member-row--member-id">
                {isConflicting && <div className="validation-error">{t('users.members.validation.conflict-with-roles')}</div>}{assignedMember.memberId}
            </div>
            <div className="member-cell member-row--balancing-group">{assignedMember.balancingGroup}</div>
            <div className="member-cell member-row--name">{assignedMember.name}</div>
            <div className="member-cell member-row--phone">{assignedMember.phone}</div>
            <div className="member-cell member-row--emails">{assignedMember.emails}</div>
        </div>
    );
}

export default UserMemberAssignmentRow;
